import React, { useState } from 'react';
import { faqs } from '../data/mockData';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQSection = () => {
  const [openItem, setOpenItem] = useState(null);

  return (
    <section id="faq" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-start">
          {/* Left side - FAQ content */}
          <div>
            {/* Section Header - 15% larger */}
            <div className="mb-20">
              <span className="text-[#00A86B] font-bold text-base tracking-wider">FAQ</span>
              <h2 className="text-5xl md:text-6xl font-black text-[#0A1628] mt-5 mb-3">
                QUESTIONS?
              </h2>
              <h2 className="text-5xl md:text-6xl font-black text-[#00A86B] mb-8">
                ANSWERS.
              </h2>
            </div>

            {/* FAQ Accordion - 15% larger */}
            <Accordion 
              type="single" 
              collapsible 
              className="space-y-5"
              onValueChange={(value) => setOpenItem(value)}
            >
              {faqs.map((faq, index) => {
                const isOpen = openItem === `item-${index}`;
                return (
                  <AccordionItem 
                    key={index} 
                    value={`item-${index}`}
                    className={`faq-item rounded-xl shadow-sm border-none overflow-hidden transition-colors duration-300 ${
                      isOpen ? 'bg-[#0A1628]' : 'bg-gray-50'
                    }`}
                  >
                    <AccordionTrigger className={`px-7 py-5 hover:no-underline transition-colors duration-300 ${
                      isOpen ? 'bg-[#0A1628] hover:bg-[#0A1628]' : 'hover:bg-gray-100'
                    }`}>
                      <div className="flex items-center gap-5 text-left">
                        <span className={`font-bold text-xl transition-colors duration-300 ${
                          isOpen ? 'text-[#00A86B]' : 'text-[#C2A23A]'
                        }`}>
                          {String(index + 1).padStart(2, '0')}
                        </span>
                        <span className={`font-bold text-lg transition-colors duration-300 ${
                          isOpen ? 'text-white' : 'text-[#0A1628]'
                        }`}>{faq.question}</span>
                      </div>
                    </AccordionTrigger>
                    <AccordionContent className={`px-7 pb-5 pt-0 transition-colors duration-300 ${
                      isOpen ? 'bg-[#0A1628]' : ''
                    }`}>
                      <div className={`pl-14 text-base transition-colors duration-300 ${
                        isOpen ? 'text-gray-300' : 'text-gray-600'
                      }`}>
                        {faq.answer}
                      </div>
                    </AccordionContent>
                  </AccordionItem>
                );
              })}
            </Accordion>
          </div>

          {/* Right side - Brothers image - 20% larger, static, aligned with questions */}
          <div className="hidden lg:flex justify-center items-start pt-32">
            <img 
              src="https://customer-assets.emergentagent.com/job_green-funding-bros/artifacts/f4m0a8bs_brothers.png"
              alt="The Bros"
              className="w-[540px] h-auto object-contain"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
